module.exports = __webpack_public_path__ + "img/success.6f9b7652.png";